const unsupported = {
	group: "block",
	content: "block+",
	defining: true,
	attrs: {
		source: { default: null },
		url: { default: null },
		type: { default: null },
		code: { default: null },
	},
};

export default unsupported;
